import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d644b6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-svg-name", "data-svg-index", "innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "opacity-25 gap-1 flex items-center flex-col relative pb-[20px]"
}
const _hoisted_4 = ["innerHTML"]

import { computed, PropType, Ref } from 'vue';
import slugify from 'slugify';
import { orderBy } from 'lodash';

import { useGetServiceQuery } from '@/entities/services/hooks';
import { useGetInspectionGroupQuery } from '@/entities/inspection-group/hooks';
import { useGetInspectionDeviceTree, useGetInspectionQuery } from '@/entities/inspection/hooks';
import { Inspection } from '@/entities/inspection/types';

import { NkGroup, NkText, NkStack } from '@/core/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'InspectionDevicesTree',
  props: {
  inspection: {
    type: Number as PropType<Inspection['id']>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const inspectionQueryData: Ref = computed(() => ({ id: props.inspection }));
const hasInspectionQueryData = computed(() => !!inspectionQueryData.value.id);
const { data: inspection } = useGetInspectionQuery(inspectionQueryData, { enabled: hasInspectionQueryData });

const inspectionGroupQueryData: Ref = computed(() => ({ id: inspection.value?.inspectionGroup }));
const hasInspectionGroupQueryData = computed(() => !!inspectionGroupQueryData.value.id);
const { data: inspectionGroup } = useGetInspectionGroupQuery(inspectionGroupQueryData, {
  enabled: hasInspectionGroupQueryData,
});

const serviceQueryData: Ref = computed(() => ({ id: inspectionGroup.value?.service }));
const hasServiceQueryData = computed(() => !!serviceQueryData.value.id);
const { data: service } = useGetServiceQuery(serviceQueryData, { enabled: hasServiceQueryData });

const isVolta = computed(() => service.value && slugify(service.value.name, { lower: true }).includes('volta'));

const deviceTreeQueryData: Ref = computed(() => ({ id: inspection.value?.inspectionGroup }));
const hasDeviceTreeQueryData = computed(() => !!deviceTreeQueryData.value?.id);
const { data: deviceTreeData } = useGetInspectionDeviceTree(deviceTreeQueryData, {
  enabled: hasDeviceTreeQueryData,
});

const addOrder = (object: any) => ({
  ...object,
  name: object.typeId === 2 && isVolta.value ? 'Wind Turbine' : object.name,
  // eslint-disable-next-line no-nested-ternary
  order: object.typeId === 4 ? 1 : object.typeId === 5 ? 3 : object.typeId === 22 ? 2 : 0,
  children: orderBy(object.children, ['typeOrder'], ['asc']),
});

const orderedDeviceTreeData = computed(() => {
  if (isVolta.value) {
    // return orderBy(deviceTreeData.value?.map(o => addOrder(o)), ['order'], ['asc']);
    return deviceTreeData.value?.map(o => addOrder(o));
  }

  return deviceTreeData.value;
});

const getSlug = (name: string) => slugify(name, {
  lower: true,
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderedDeviceTreeData), (device, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: device.id,
      class: "bg-gray-100 py-2 px-4"
    }, [
      _createVNode(_unref(NkGroup), {
        spacing: 4,
        grow: "",
        "no-wrap": "",
        align: "stretch"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkStack), {
            spacing: 5,
            class: "flex-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkText), {
                type: "extra-small",
                align: "center"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(device.name), 1)
                ]),
                _: 2
              }, 1024),
              (device?.svg)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "device-svg-coloration flex-1",
                    "data-svg-name": getSlug(device.typeName),
                    "data-svg-index": index,
                    innerHTML: device.svg
                  }, null, 8, _hoisted_1))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024),
          _createVNode(_unref(NkStack), { spacing: 5 }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkText), {
                type: "extra-small",
                align: "center"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('misc.sides')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(NkGroup), {
                class: "flex-1",
                "no-wrap": "",
                position: device?.children?.length > 1 ? 'apart' : 'center'
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(device?.children, (subDevice) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: subDevice.id
                    }, [
                      (subDevice.inspection)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "block relative pb-[20px]",
                            to: {
                    name: 'visionair-inspection',
                    params: {
                      inspection: subDevice.inspection,
                    },
                    query: {
                      view: _ctx.$route.query.view,
                    }
                  }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                class: _normalizeClass(["flex justify-center", {
                      'is-highlighted': subDevice.id === _unref(inspection)?.device,
                      'rotate-180': subDevice?.isReverse,
                    }]),
                                "data-svg-highlight": "",
                                innerHTML: subDevice.svg
                              }, null, 10, _hoisted_2),
                              _createVNode(_unref(NkText), {
                                class: "absolute bottom-0 transform left-1/2 -translate-x-1/2",
                                type: "bold-xxs2",
                                align: "center"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(subDevice.name), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("span", {
                              title: "No inspection",
                              innerHTML: subDevice.svg
                            }, null, 8, _hoisted_4),
                            _createVNode(_unref(NkText), {
                              class: "absolute bottom-0 transform left-1/2 -translate-x-1/2",
                              type: "bold-xxs2",
                              align: "center"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(subDevice.name.replace(/\-/g, '')), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                    ], 64))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["position"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024)
    ]))
  }), 128))
}
}

})